import { useParams, useNavigate } from "react-router-dom";
import { Image, Button } from "@nextui-org/react";
import SectionHeading from "../../components/Typography/SectionHeading";
import { getArticleBySlug } from "./articles";

function BlogPost() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  const article = slug ? getArticleBySlug(slug) : undefined;

  if (!article) {
    return (
      <section className="container pt-16 tablet:py-0">
        <div className="mx-auto max-w-3xl px-6 pb-24 text-center">
          <SectionHeading text="Article Not Found" />
          <p className="mb-8 text-neutral-600 dark:text-neutral-400">
            The article you're looking for doesn't exist.
          </p>
          <Button onPress={() => navigate("/blog")} color="primary">
            Back to Blog
          </Button>
        </div>
      </section>
    );
  }

  return (
    <section className="container pt-8 tablet:py-0">
      <div className="mx-auto max-w-3xl px-6 pb-24">
        <nav className="pb-4 tablet:pt-16 tablet:pb-6">
          <Button
            onPress={() => navigate("/blog")}
            variant="light"
            className="px-0"
          >
            ← Back to Blog
          </Button>
        </nav>

        <SectionHeading compact text={article.title} />

        {article.image && (
          <div className="mb-8">
            <Image
              src={article.image}
              alt={article.title}
              className="w-full rounded-lg"
            />
          </div>
        )}

        <article
          className="font-sans text-lg leading-relaxed whitespace-pre-line"
          dangerouslySetInnerHTML={{ __html: article.content || article.body }}
        />
      </div>
    </section>
  );
}

export default BlogPost;
